// Shared v3 class strings. Tailwind scans .ts files, so these compile normally.
//
// Direction: Linear-style. Medium-weight display type (510) with -0.022em
// tracking, a few far-apart sizes, near-monochrome color, hairlines instead
// of cards, pill buttons. Shape rule: buttons are pills; product frames and
// inputs are rounded-lg/xl; nothing in between.

const FOCUS =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cp-accent';

const BTN_BASE =
  `inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full font-[510] transition-colors duration-150 ${FOCUS} ` +
  'disabled:cursor-not-allowed disabled:opacity-40';

/** Large pill, primary (high-contrast fill). */
export const BTN_PRIMARY = `${BTN_BASE} h-11 px-5 text-[15px] bg-cp-btn text-cp-btn-fg hover:bg-cp-btn/85`;

/** Large pill, secondary (translucent fill). */
export const BTN_SECONDARY = `${BTN_BASE} h-11 px-5 text-[15px] bg-cp-fill text-cp-ink hover:bg-cp-ink/10`;

/** Compact pill for the navbar. */
export const BTN_PRIMARY_SM = `${BTN_BASE} h-8 px-3.5 text-[13px] bg-cp-btn text-cp-btn-fg hover:bg-cp-btn/85`;

export const TEXT_LINK = `inline-flex items-center gap-1 rounded-sm text-[15px] text-cp-ink transition-colors hover:text-cp-muted ${FOCUS}`;

export const FIELD =
  'block w-full rounded-lg border border-cp-line-strong bg-transparent px-3.5 py-2.5 text-[15px] text-cp-ink ' +
  'placeholder:text-cp-subtle transition-colors hover:border-cp-ink/25 focus:border-cp-ink/40 focus:outline-none focus:ring-4 focus:ring-cp-ink/5';

export const SECTION_INNER = 'mx-auto max-w-[1200px] px-5 sm:px-8';

/** Vertical rhythm shared by every section (Linear uses a flat 128px). */
export const SECTION_PAD = 'py-24 lg:py-32';

const DISPLAY = 'font-[510] tracking-[-0.022em] text-cp-ink';

export const H1 = `${DISPLAY} text-[2.75rem] leading-[1.02] sm:text-[3.5rem] lg:text-[4rem]`;

export const H2 = `${DISPLAY} text-[2rem] leading-[1.06] sm:text-[2.5rem] lg:text-[3rem] lg:leading-[1.02]`;

export const H_CLOSE = `${DISPLAY} text-[2.25rem] leading-[1.06] sm:text-[3rem] lg:text-[3.5rem] lg:leading-[1.04]`;

export const H3 = 'text-[17px] font-[510] tracking-[-0.011em] text-cp-ink';

/** Secondary copy next to a headline: 17px gray, tight measure. */
export const LEAD = 'text-[17px] leading-[1.6] text-cp-muted';

export const BODY = 'text-[15px] leading-[1.6] text-cp-muted';
